import { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { APIURL, STORAGEURL } from ".";
import parse from 'html-react-parser';
import Loading from "./components/UI/Loading";
import Header from "./components/Header/Header";
import Navigation, { HeaderLink } from "./components/Header/Navigation";
import Hamburger from "./components/Header/Hamburger";
import Overlay from "./components/Header/Overlay";
import { initCookieConsent, showCookieConsent } from "./components/UI/Cookies";
import ReactPlayer from "react-player";
import Form from "./components/Form/Form";
import Input from "./components/Form/Input";
import Dropdown from "./components/Form/Dropdown";
import Checkbox from "./components/Form/Checkbox";
import { useToast } from "./components/UI/useToast";
import { Link } from "react-router-dom";
import linky from "./assets/events.png";
import footer from "./assets/footer.png";
import hero from "./assets/hero.svg";
import web from "./assets/web.svg";
import email from "./assets/email.svg";
import Submit from "./components/Form/Submit";

const HP = () => {
  const headerRef = useRef();
  const [data, setData] = useState();
  const [form, setForm] = useState();
  const [formLoading, setFormLoading] = useState(false);
  const { addToast } = useToast();
  const formRef = useRef();

  const handleSubmit = (data) => {
      let dataForm = form?.inputs.map((d, i) => ({ id: d.id, value: d.type==='select'?data[d.name].map(v=>v.label).join(","):data[d.name] }));
      setFormLoading(true);
      axios
          .post(APIURL + "/newAnswer", {data: dataForm, name:'contact',language: "cs"})
          .then((response) => {
              addToast({type: "success",message: "Váš požadavek byl odeslán."});
              formRef.current?.reset();
              setFormLoading(false);
          })
          .catch((err) => {
              addToast({type: "error",message:"Nastala se chyba, kontaktujte nás prosím na admin@agenturagen.cz."});
          });
  };

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      initCookieConsent();
    }
  }, []);

  const getPageData = async () => {
    await axios.post(APIURL + "/page", { name: "hp", language: 'cs' }).then(response => {
      setData(response.data.body);
    })
    await axios.post(APIURL+"/form", {name:'contact', language:'cs'}).then(response => {
      setForm(response.data.body)
    })
  };

  useEffect(() => {
      getPageData();
  }, []);

  const formatDates = (date1, date2) => {
    const d1 = new Date(date1);
    let result = `${d1.getDate()}. `;
    if (date2) {
        const d2 = new Date(date2);
        if (d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear()) {
            result += `${d1.getMonth() + 1}. ${d1.getFullYear()}`;
        } else if (d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear()) {
            result += `- ${d2.getDate()}. ${d1.getMonth() + 1}. ${d1.getFullYear()}`;
        } else if (d1.getFullYear() === d2.getFullYear()) {
            result += `${d1.getMonth() + 1} - ${d2.getDate()}. ${d2.getMonth() + 1}. ${d1.getFullYear()}`;
        } else {
            result = `${d1.getDate()}. ${d1.getMonth() + 1}. ${d1.getFullYear()} - ${d2.getDate()}. ${d2.getMonth() + 1}. ${d2.getFullYear()}`;
        }
    } else {
        result += `${d1.getMonth() + 1}. ${d1.getFullYear()}`;
    }
    return result;
  }

  if (!data) {return <Loading />} else
  return (
    <>
      <Header fixed stopScroll ref={headerRef}> 
        <div className="maxSection m-auto flex justify-between items-center bg-bluee-light-200 pb-8" style={{filter:"url(#remove-black"}}>
          <div className="absolute bottom-0 left-4 mobil:left-2 w-[calc(100%-2rem)] mobil:w-[calc(100%-1rem)] h-8 bg-black rounded-t-xl"></div>
          <HeaderLink to="#start"><img src={STORAGEURL+data.logo} alt="Logo" className="max-h-8" /></HeaderLink>
          <Navigation hideOnMobile={1000} moveRight className="!py-6 uppercase [&_.sfx]:!text-xs font-semibold">          
            <HeaderLink to="#projekt" className="sfx">O projektu</HeaderLink> 
            <HeaderLink to="#udalosti" className="sfx">Události</HeaderLink> 
            <HeaderLink to="#kontakt" className="sfx">Kontakt</HeaderLink>
          </Navigation>
          <Hamburger lineclassName='!bg-base-color' show={1000} />
        </div>
        <Overlay className="bg-bluee-light-200 shadow-lg gap-6 uppercase font-semibold" hamburgerClassName="!absolute !right-4 !top-4" direction="top" height="fit-content" width="100%" data-lenis-prevent >
          <HeaderLink to="#projekt" className="sfx">O projektu</HeaderLink> 
          <HeaderLink to="#udalosti" className="sfx">Události</HeaderLink> 
          <HeaderLink to="#kontakt" className="sfx">Kontakt</HeaderLink>
        </Overlay>
      </Header>

      <main className="overflow-x-hidden w-full min-h-[60vh] maxSection flex flex-col items-center gap-6" id='start'>
        <section className="w-full mt-8 bg-gradientik rounded-2xl overflow-hidden">
          {data.hero&&<video src={STORAGEURL+data.hero} autoPlay loop muted playsInline controls={false}
          width="100%" height="100%" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl w-full h-full mobil:!w-auto mobil:!max-w-none" />}
          <div className="bg-gradientikNoBg absolute -left-1/2 bottom-0 w-[200%] h-full"></div>
          <div className="w-full rounded-xl nemobil:aspect-video mobil:h-[85vh] py-7 flex flex-col justify-center mobil:justify-end items-center mobil:items-start text-center mobil:text-left mobil:px-4 text-white" style={{backgroundColor:`rgba(2, 22, 33, ${data.opacity||0.5})`}}>
            <img src={hero} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-11/12 max-w-2xl mobil:hidden" />
            <h1 className="w-4/5 max-w-xl 3xl:max-w-2xl 3xl:text-7xl">{data.h1}</h1>
            <p className="pb-7 pt-3 w-4/5 mobil:w-full max-w-4xl">{data.intro}</p>
            {data.intro_button&&<Link to="#form" className="button  mobil:!self-center"><span>{data.intro_button}</span></Link>}
          </div>
        </section>

        <section className="bg-white border-2 border-bluee-outline flex flex-col items-center py-14 gap-14 px-7 mobil:px-4 rounded-xl " id="projekt">
          <div className="w-11/12 flex mobil:flex-col-reverse mobil:text-center justify-center items-center gap-7">
            <div className="max-w-[40%] mobil:max-w-full">
              <h2>{data.about_h2}</h2>
              <div className="parsedDiv !text-sm">{parse(data.about_perex)}</div>
            </div>
            <img src={STORAGEURL+data.about_img} alt="about obrázek" className="nemobil:max-w-[50%]" />
          </div>
        
          <div className="2xl:w-5/6 flex gap-4 3xl:gap-8 mobil:flex-col text-center">
            {data.about_items?.map(i=>(
              <div key={i.item_name} className={"p-6 3xl:p-10 rounded-xl flex-1 text-left flex flex-col items-start "+(i.bg_colour.toLowerCase().includes('fff')?"border-bluee-outline border-2":"")} style={{backgroundColor:i.bg_colour,color:i.text_colour}}>
                <img src={STORAGEURL+i.logo} alt={i.item_name} className="max-w-[75%]" />
                <h3>{i.item_name}</h3>
                <div className="parsedDiv !text-sm !pb-10">{parse(i.text||'')}</div>
                <a className="button dark outline !mt-auto" href={i.link} target="_blank"><span>Zobrazit web</span></a>
              </div>
            ))}
          </div>
        </section>

        <section className="w-full bg-gradientik text-white flex flex-col items-center py-14 px-7 rounded-xl text-center overflow-hidden" id="udalosti">
          <img className="absolute w-full top-1/2 -translate-y-1/2" src={linky} />
          <h2>{data.events_h2}</h2>
          <div className="parsedDiv !max-w-md">{parse(data.events_perex||"")}</div>
          <div className="w-11/12 flex flex-wrap gap-7 pt-7 justify-center items-center mobil:flex-col">
            {data.events?.map(e=>(
              <div key={e.id} className="p-6 rounded-xl bg-white text-left text-bluee-dark-100 lg:w-[calc(33%-2rem)] md:w-[calc(50%-2rem)] w-full flex flex-col lg:aspect-[5/3]">
                <p>{formatDates(e.date,e.date_to)}</p>
                <h3>{e.name}</h3>
                <p>{e.place}</p>
                <div className="mt-auto flex justify-between items-center pt-7">
                  <p>{e.price}</p>
                  {e.link&&<a className="button dark smol" target="_blank" href={e.link}></a>}
                </div>
              </div>
            ))}
          </div>
        </section>

        {form&&<section id="kontakt" className="pt-8 bg-base-gradient">
          <div className="maxSection !w-11/12 flex justify-between items-center mobil:flex-col">
            <div className="nemobil:w-1/2 p-7 mobil:px-0 mobil:pb-0 text-bluee-dark-100">
              <div className="max-w-sm">
                <h2 className="m-0">{parse(data.form_heading||"")}</h2>
                <div className="parsedDiv">
                  {parse(data.form_text||"")}
                  <div className="pt-4 pb-2 flex items-center gap-4"><img src={email}/> <a href={"mailto:"+data.form_email} className="!text-sm" target="_blank">{data.form_email}</a> </div>
                  <div className="flex items-center gap-4"><img src={web}/> <a href={data.form_web} className="!text-sm !no-underline" target="_blank">{data.form_web.replace(/^https?:\/\//, '').replace(/\/$/, '')}</a> </div>
                </div>
              </div>
            </div>
            <div className="nemobil:w-1/2 p-7 mobil:px-0 mobil:pt-0" id="form">
                <Form onSubmit={handleSubmit} ref={formRef}> 
                    {form?.inputs?.map((input, index) =>
                        (input.type === "input" || input.type === "textarea") ? (
                        <Input
                            key={input.id}
                            label={input.label}
                            name={input.name}
                            placeholder={input.placeholder}
                            className={`${(input.type === "textarea"||input.input_type==="number") ? "" : "half"}`}
                            required={input.required ? true : false}
                            type={input.input_type||input.type}
                        />
                        ) :
                        (input.type === "select")?(
                            <Dropdown
                                key={input.id}
                                label={input.label}
                                name={input.name}
                                placeholder={input.placeholder}
                                options={input.options}
                                isMulti={input.multiple}
                                className="half"
                            />
                        ):<></>
                    )}
                    <Checkbox name="GDPR" className="basis-full !text-sm mobil:!text-xs pt-7 pb-4" required>Souhlasím s <a href={STORAGEURL+data.gdpr} target="_blank" >GDPR</a></Checkbox>
                    <Submit isSubmitting={formLoading} className="dark"><span>Odjednat</span></Submit>
                </Form>
            </div>
          </div>
          <div className="flex justify-center items-center tablet:flex-wrap p-7 gap-7 border-t border-[#B8C0C6]">
            {data.logos?.map(logo=>(
              <a key={logo.item_name} href={logo.url} target="_blank">
                <img src={STORAGEURL+logo.logo} alt={logo.item_name} />
              </a>
            ))}
          </div>
        </section>}
      </main>
      <footer className='mt-auto w-full max-w-full overflow-x-hidden pb-12 text-white bg-gradientik'> 
        <img className="absolute w-full max-h-full object-cover top-1/2 -translate-y-1/2" src={footer} />
        <div className="w-full h-20 bg-bluee-light-200 rounded-b-3xl"></div>
        <div className="maxSection"> 
          <div className="p-14 rounded-xl flex flex-row mobil:flex-col-reverse gap-8 w-full justify-center items-center">
              <div className="flex flex-col justify-between mobil:items-center">
                <img src={STORAGEURL+data.logo} alt="Logo " className="max-w-[50%] mobil:max-w-full invert saturate-0" />
                <p className="text-xs pt-6 nemobil:pr-4 mobil:text-center font-extralight">Copyright © 2025 Platforma VIZE 0, z. ú. | Design by Agentura GEN</p>
              </div>
              <div> 
                <Link to="#projekt" className="sfx">O projektu</Link> 
                <Link to="#udalosti" className="sfx">Události</Link> 
                <Link to="#kontakt" className="sfx">Kontakt</Link> 
              </div>
              <div> 
                <a href={STORAGEURL+data.gdpr} target="_blank" className="sfx">GDPR</a> 
                <a onClick={showCookieConsent} className="sfx">Nastavení soukromí</a>  
              </div>
              <div className="pl-4 flex gap-2">
                {data.socials?.map(s=>(
                  <a href={s.item_name} key={s.item_name}  target="_blank"><img src={STORAGEURL+s.icon} alt={s.item_name} /></a>
                ))}
              </div>
            </div>
        </div>
      </footer>

      <svg width="0" height="0">
            <filter id="remove-black" colorInterpolationFilters="sRGB">
              <feColorMatrix
                type="matrix"
                values="1 0 0 0 0
                        0 1 0 0 0
                        0 0 1 0 0
                        -255 -255 -255 0 1"
                result="black-pixels"
              />
              <feMorphology
                in="black-pixels"
                operator="dilate"
                radius="0.5"
                result="smoothed"
              />
              <feComposite in="SourceGraphic" in2="smoothed" operator="out" />
            </filter>
          </svg>
    </>
  );
};

export default HP;